import { gql } from '@apollo/client';
import { useFetchCallback } from './useFetchCallback';

const GET_CLIENT_INVESTMENTS_QUERY = gql`
  query getClientInvestments {
    getClientInvestments {
      id
      name
      fileAs
      fmtUnitBalance
      unitBalance
      fmtMarketValue
      marketValue
      fmtCapitalAppreciation
      capitalAppreciation
      fmtDividends
      dividends
      fmtBuy
      buy
      fmtSell
      sell
      fmtProfitPercent
      profitPercent
      currency
      unitValue
      custom
    }
  }
`;
{
  /*Retorna un array de objetos con las inversiones del usuario*/
}

const GET_CLIENT_INVESTMENTS_BACKUP = gql`
  query GetClientFundsInvestmentsBackup {
  getClientFundsInvestmentsBackup {
    buy
    capitalAppreciation
    currency
    custom
    dividends
    fileAs
    fmtBuy
    fmtCapitalAppreciation
    fmtDividends
    fmtMarketValue
    fmtProfitPercent
    fmtSell
    fmtUnitBalance
    id
    marketValue
    name
    profitPercent
    sell
    unitBalance
    unitValue
  }
}
`;

export const useGetClientInvestmentsWithFallback = () => {
  return useFetchCallback(GET_CLIENT_INVESTMENTS_QUERY, GET_CLIENT_INVESTMENTS_BACKUP, {
    fetchPolicy: 'no-cache',
  });
};

//export default () => useQuery(GET_CLIENT_INVESTMENTS_QUERY, { fetchPolicy: 'no-cache' });
